import styled from 'styled-components';

export const DateValueContainer = styled.div`
	margin-left: 8px;
`;

export const ArrowContainer = styled.div`
	margin-top: 6px;
	margin-right: 10px;
`;
